<template lang="pug">
  v-container.pa-0
    v-layout.my-6.px-2.pt-2(v-if="isFetching")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
    .content-layout(v-else)
      v-layout.my-6.px-2.pt-2(v-if="creditHistories.length == 0")
        v-row.fill-height.ma-0(align='center' justify='center')
          div.mx-auto
            v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
            div.p2.basic600--text.text-center No credit history found.
      div(v-else)
        v-card.round-xl(outlined)
          template(v-for="(credit, index) in creditHistories")
            div(:key="credit.group")
              div.text-md.font-semibold.neutral300.neutral700--text.px-4.py-2 {{ credit.group }}
              credit-history-item(v-for="(item, itemIndex) in credit.items" :key="item.ref" :item="item" :index="itemIndex" :totalItems="credit.items.length" @selected="$emit('selected', $event)")
      div.py-3.px-4
        y-pagination.ma-4(v-model="page" :pageSize="pageSize" :count="count")

</template>

<script>
import { mapActions } from 'vuex'
import { DateTime } from 'luxon'
import CreditHistoryItem from '@/components/clinic/marketing/CreditHistoryItem.vue'

export default {
  components: { CreditHistoryItem },
  props: {
    company: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: () => ({
    isFetching: false,
    fetchUrl: '/billing/prepaid_credit_history/',
    page: 1,
    pageSize: 20,
    count: 0,
    creditHistories: [],
    selectedDetail: null,
    openDetailsSheet: false,
    openCreditHistoryReceiptDialog: false
  }),
  computed: {
    filterParams() {
      return {
        company: this.company.id,
        page: this.page,
        page_size: this.pageSize
      }
    }
  },
  async mounted() {
    this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1
    await this.fetchCreditHistory()
    if (this.$route.query.ref) {
      this.findRef(this.$route.query.ref)
    }
  },
  watch: {
    async page(val) {
      this.$router.replace({ hash: this.$route.hash, query: { page: val, ref: this.$route.query.ref } }).catch(() => {})
      if (!this.isFetching) {
        await this.fetchCreditHistory()
      }
      if (this.$route.query.ref) {
        this.findRef(this.$route.query.ref)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchCreditHistory() {
      this.isFetching = true
      return this.axios
        .get(this.fetchUrl, { params: this.filterParams })
        .then(resp => {
          const formattedData = this.formatCreditHistory(resp.data.results)
          this.creditHistories = this.groupCreditHistory(formattedData)
          this.count = resp.data.count
          this.isFetching = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    formatCreditHistory(dataArr) {
      // Credit list title
      function getTitle(obj) {
        if (!obj.data) {
          return 'Credit reload'
        }
        if (obj.data.books_reminder) {
          return 'Send reminder'
        }
        if (obj.data.ys_fulfilment) {
          const fulfilment = obj.data.ys_fulfilment
          return `${fulfilment.shipping_type} ${fulfilment.order_type.toLowerCase()}`
        }
        if (obj.data.ys_adjustment) {
          return 'Shipping weight discrepancy'
        }
        if (obj.data) {
          const [key] = Object.keys(obj.data)
          const formattedKey = key.replace(/_/g, ' ');
          return formattedKey.charAt(0).toUpperCase() + formattedKey.slice(1);
        }
      }
      // Credit list type
      function getType(obj) {
        if (!obj.data) {
          return 'Wallet'
        } else {
          if (obj.data.books_reminder) {
            return 'Books'
          }
          if (obj.data.ys_fulfilment) {
            return 'Shipping'
          }
          if (obj.data.ys_adjustment) {
            return 'Shipping Adjustment'
          }
          return null
        }
      }
      return dataArr.map(obj => {
        const title = getTitle(obj)
        const type = getType(obj)
        return {
          ...obj,
          title,
          type
        }
      })
    },
    groupCreditHistory(items) {
      return items.reduce((acc, item) => {
        const yearMonth = DateTime.fromISO(item.created.substring(0, 7)).toFormat('MMMM yyyy')
        const index = acc.findIndex(group => group.group === yearMonth)
        if (index === -1) {
          acc.push({
            group: yearMonth,
            items: [item]
          })
        } else {
          acc[index].items.push(item)
        }
        return acc
      }, [])
    },
    selected(item) {
      this.selectedDetail = item
      this.openDetailsSheet = true
    },
    async findRef(ref) {
      let found
      this.creditHistories.forEach(data => {
        found = data.items.find(item => item.ref === ref)
        if (found) {
          this.selectedDetail = found
          this.openCreditHistoryReceiptDialog = true
          this.$router.replace({ hash: this.$route.hash, query: { page: this.page } }).catch(() => {})
          return
        }
      })
      if (!found) {
        this.page++
      }
    }
  }
}
</script>